module.exports = __webpack_public_path__ + "assets/a_tenbis-c56c23.svg";